import { useState , useEffect } from 'react'
import { BASE_PATH_API } from 'constants/env'
import useProductsIDs from './useProductsIDs'

const productArray = (product) => {
    const idsProduct = product.map( ids => Number(ids?.product_id) )  
    return idsProduct
}

const useEventGifts = () => {
    const {
        getProductsByFilter,
        responseProduct
    } = useProductsIDs()

    const [ responseTable, setResponseTable ] = useState(false)
    const [ responseTableStore, setResponseTableStore ] = useState(false)
    const [ responseGifts, setResponseGifts ] = useState(false)
    const [ responseEmpryGifts, setResponseEmptyGifts ] = useState(false)

    const [ respProducts, setRespProducts ] = useState(false)
    const [ totalProducts, setTotalProducts ] = useState(false)
    const [ total, setTotal ] = useState(false)
    const [ products, setProducts ] = useState(false)
    const [ prodOriginal, setProdOriginal ] = useState(false)
    const [ prodASC, setProduASC ] = useState(false)
    const [ prodDES, setProduDES ] = useState(false)
    const [ prodTotalASC, setProdTotalASC ] = useState(false)
    const [ prodTotalDES, setProdTotalDES ] = useState(false)
    const [ orden, setOrden ] = useState(1)
    const [ catFilter, setCatFilter ] = useState('Categorías')
    const [ categories, setCategories ] = useState(false)
    const [ isEmpty, setIsEmpty ] = useState(false)


    const getEventTable = async (eventID) => {
        const idsFilter = String(eventID)
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/${idsFilter}?is_guest=false`);
            const data = await response.json();
            setResponseTable(data?.data)
        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const handleOrdenar = (event) => {
        const { value } = event?.target
        setOrden( Number(value) )
    }

    const handleCategorias = (event) => {
        const { value } = event?.target
        setCatFilter( String(value) )
    }


    useEffect(()=>{
        if(responseTable){
            if(responseTable?.gifts){
                if(responseTable?.gifts?.length >= 1){
                    setResponseGifts(responseTable?.gifts)
                }else{
                    setResponseEmptyGifts(true)
                }
            }else{
                setResponseEmptyGifts(true)
            }
            if(responseTable?.gifts_only_store){
                if(responseTable?.gifts_only_store?.length >= 1){
                    const gifts_only_store = responseTable?.gifts_only_store
                    const singleProduct =  gifts_only_store?.filter( (prod, index, self) => index === self?.findIndex((t) => t?.sku === prod?.sku))

                    setResponseTableStore(singleProduct)
                }
            } 
        }
    },[responseTable])

    useEffect(()=>{
        if(responseGifts){
            getProductsByFilter( productArray(responseGifts) ) 
        }
    },[responseGifts])

    useEffect(()=>{
        if(responseProduct){

            // console.log('responseProduct: ', responseProduct)
            // console.log('responseGifts: ', responseGifts)
            // console.log('responseTable: ', responseTable)

            if(responseProduct?.length >= 1){
                const responseMerge = responseProduct.map(productMerge => {
                    const gifts = responseGifts.filter(gift => gift.product_id === productMerge?.id)[0]
                    const celebrate = responseTable?.celebrate_labels
                    const amount = gifts?.amount
                    const gifted = gifts?.gifted
                    const quantity_for_gift = gifts?.quantity_for_gift
                    const variantSelected = gifts?.children_sku ? gifts?.children_sku : []
                    const variant_id = gifts?.variant_id ? gifts?.variant_id : null
                    const fusion = {
                        ...productMerge,
                        amount,
                        celebrate,
                        gifted,
                        quantity_for_gift,
                        variantSelected,
                        variant_id
                    }
                    return fusion
                })
                setRespProducts(responseMerge)
                // console.log('responseMerge: ', responseMerge)
            }else{
                setIsEmpty(true)
                setRespProducts([])
                // console.log('no hay datos')
            }
        }
    },[responseProduct])

    useEffect(()=>{
        const nivel = 1
        if(respProducts){
            const originalProductos = respProducts.filter(product => product?.stock >= 1 && product?.is_active === true )
            const arrayASC = [ ...originalProductos ]
            const arrayDES = [ ...originalProductos ]
            const ASC = arrayASC.sort( (a, b) => b?.pricing?.list_price - a?.pricing?.list_price )
            const DES = arrayDES.sort( (a, b) => a?.pricing?.list_price - b?.pricing?.list_price )

            const categoryArray = []
            originalProductos.map(category => {
                if(category?.categories?.length >=1){
                    const categoryName = category?.categories[0][nivel]?.name;
                    if (!categoryArray.includes(categoryName)) {
                        categoryArray.push(categoryName);
                    }
                }else{
                    const categoryName = 'Otros';
                    if (!categoryArray.includes(categoryName)) {
                        categoryArray.push(categoryName);
                    }
                }
                return false
            })
            setCategories(categoryArray)

            const newArrayProducts = categoryArray.map( catArray => {
                let prod
                if(catArray !== 'Otros'){
                    const onlyCat = originalProductos.filter(productoFilter => productoFilter?.categories?.length >= 1 ) 
                    prod = onlyCat.filter(productoFilter => productoFilter?.categories[0][nivel]?.name === catArray)
                }else{
                    try{
                        prod = originalProductos.filter(productoFilter => typeof productoFilter?.categories === 'object' && Object.keys(productoFilter?.categories)?.length === 0)
                    }catch(e){
                        prod = originalProductos.filter(productoFilter => productoFilter?.categories === null)
                    }
                }
                const prodArray = {
                    categoria: catArray,
                    product: prod
                }
                return prodArray
            })
        
            const newArrayProductsASC = categoryArray.map( catArray => {
                let prod
                if(catArray !== 'Otros'){
                    const onlyCat = ASC.filter(productoFilter => productoFilter?.categories?.length >= 1 ) 
                    prod = onlyCat.filter(productoFilter => productoFilter?.categories[0][nivel]?.name === catArray)
                }else{
                    try{
                        prod = ASC.filter(productoFilter => typeof productoFilter?.categories === 'object' && Object.keys(productoFilter?.categories)?.length === 0)
                    }catch(e){
                        prod = ASC.filter(productoFilter => productoFilter?.categories === null)
                    }
                }
                const prodArray = {
                    categoria: catArray,
                    product: prod
                }
                return prodArray
            })

            const newArrayProductsDES = categoryArray.map( catArray => {
                let prod
                if(catArray !== 'Otros'){
                    const onlyCat = DES.filter(productoFilter => productoFilter?.categories?.length >= 1 )
                    prod = onlyCat.filter(productoFilter => productoFilter?.categories[0][nivel]?.name === catArray)
                }else{
                    try{
                        prod = DES.filter(productoFilter => typeof productoFilter?.categories === 'object' && Object.keys(productoFilter?.categories)?.length === 0)
                    }catch(e){
                        prod = DES.filter(productoFilter => productoFilter?.categories === null)
                    }
                }
                const prodArray = {
                    categoria: catArray,
                    product: prod
                }
                return prodArray
            })

            const newArrayProdTotalASC = [
                {
                    categoria: '',
                    product: ASC
                }
            ]

            const newArrayProdTotalDES = [
                {
                    categoria: '',
                    product: DES
                }
            ]

            if(originalProductos?.length === 0){
                setIsEmpty(true)
                // console.log('originalProductos 1: ',originalProductos)
            }

            setTotalProducts(originalProductos)
            setTotal(originalProductos)
            setProdOriginal(newArrayProducts)
            setProducts(newArrayProducts)
            setProduASC(newArrayProductsASC)
            setProduDES(newArrayProductsDES)
            setProdTotalASC(newArrayProdTotalASC)
            setProdTotalDES(newArrayProdTotalDES)
        }
    },[respProducts])

    useEffect(()=>{
        if(catFilter){
            if(catFilter === 'Categorías'){
                setProducts(prodOriginal)
                if(orden === 1){
                    setTotal(totalProducts)
                }else if(orden === 2){
                    setProducts(prodTotalASC)
                }else if(orden === 3){
                    setProducts(prodTotalDES)
                }
            }else{
                let arrayCat
                if(orden === 1){
                    arrayCat = prodOriginal
                }else if(orden === 2){
                    arrayCat = prodASC
                }else if(orden === 3){
                    arrayCat = prodDES
                }
                const categoria = arrayCat.filter(category => category?.categoria === catFilter)
                setTotal(categoria[0]?.product)
                setProducts(categoria)
            }
        }
    },[catFilter, orden])

    return {
        getEventTable,
        responseTable,
        responseTableStore,
        responseEmpryGifts,
        respProducts,
        products,
        total,
        isEmpty,
        categories,
        handleOrdenar,
        handleCategorias
    }
}

export default useEventGifts